import { GetViewApiResponse } from "contexts/apiRequestContext";
import { createAxiosConfig, creditAxiosApi } from "services/axiosApi/axiosApi";
import { EmploymentStatusProps, EmploymentStatusReadModel } from "./types";

const url = '/EmploymentStatus';
export const getEmploymentStatusAsync = async (filters: EmploymentStatusProps, token?: string) => {
    const axiosConfig = createAxiosConfig(token!, filters);
    return await creditAxiosApi.get<GetViewApiResponse<EmploymentStatusReadModel>>(url, axiosConfig);
};